<template>
    <VerificationSubsection
        :indentation-level="1"
        title="Geolocation"
    >
        <GoogleMap
            v-if="reportMapLocation.lat && reportMapLocation.lng"
            class="h-56 w-full"
            :map-center="reportMapLocation"
            :markerCoordinates="[reportMapLocation]"
        />

        <VerificationGrid :indentation-level="1">
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_IP_ADDRESS_LOCATION)"
                label="IP Address:"
                :value="ipAnalysis.geolocation.ip"
            />

            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_IP_HOSTNAME)"
                label="Hostname:"
                :value="ipAnalysis.geolocation.hostname"
            />

            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_IP_CITY)"
                label="City:"
                :value="ipAnalysis.geolocation.city"
            />

            <CheckTextualResult
                v-tooltip.left="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_IP_REGION)"
                label="Region:"
                :value="ipAnalysis.geolocation.region"
            />

            <CheckTextualResult
                v-tooltip.left="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_IP_COUNTRY)"
                label="Country:"
                :value="ipAnalysis.geolocation.country"
            />

            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_IP_ADDRESS_LOCATION)"
                label="Location:"
                :value="ipAnalysis.geolocation.location"
            />
        </VerificationGrid>
    </VerificationSubsection>
    <VerificationSubsection
        :indentation-level="1"
        title="Privacy"
    >
        <VerificationGrid :indentation-level="1">
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_PRIVACY_VPN)"
                label="VPN:"
                :value="ipAnalysis.privacy.vpn"
            />

            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_PRIVACY_PROXY)"
                label="Proxy:"
                :value="ipAnalysis.privacy.proxy"
            />

            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_PRIVACY_TOR)"
                label="Tor:"
                :value="ipAnalysis.privacy.tor"
            />

            <CheckTextualResult
                v-tooltip.left="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_PRIVACY_RELAY)"
                label="Relay:"
                :value="ipAnalysis.privacy.relay"
            />

            <CheckTextualResult
                label="Hosting:"
                :value="ipAnalysis.privacy.hosting"
            />
        </VerificationGrid>
    </VerificationSubsection>
    <VerificationSubsection
        :indentation-level="1"
        title="Network Service"
    >
        <VerificationGrid :indentation-level="1">
            <CheckTextualResult
                label="Name:"
                :value="ipAnalysis.network.name"
            />

            <CheckTextualResult
                label="Domain:"
                :value="ipAnalysis.network.domain"
            />

            <CheckTextualResult
                label="Type:"
                :value="ipAnalysis.network.type"
            />
        </VerificationGrid>
    </VerificationSubsection>
</template>

<script lang="ts" setup>
import type { IPAddressAnalysis } from '@/api/interfaces/identity-verification-report.api';
import { computed } from 'vue';
import GoogleMap from '../../Map/GoogleMap.vue';
import CheckTextualResult from '../common/CheckTextualResult.vue';
import VerificationGrid from '../common/VerificationGrid.vue';
import VerificationSubsection from '../common/VerificationSubsection.vue';
import { GEN_IDV_STYLED_TOOLTIP } from '../common/idv-helper-tooltip.pt';
import {
    IDV_HELPER_IP_ADDRESS_LOCATION,
    IDV_HELPER_IP_CITY,
    IDV_HELPER_IP_COUNTRY,
    IDV_HELPER_IP_HOSTNAME,
    IDV_HELPER_IP_REGION,
    IDV_HELPER_PRIVACY_PROXY,
    IDV_HELPER_PRIVACY_RELAY,
    IDV_HELPER_PRIVACY_TOR,
    IDV_HELPER_PRIVACY_VPN,
} from '../idv-static-helper-text';

const props = defineProps<{
    ipAnalysis: IPAddressAnalysis;
}>();
const reportMapLocation = computed(() => ({
    lat: props.ipAnalysis.geolocation.lat,
    lng: props.ipAnalysis.geolocation.lng,
}));
</script>
